"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styles_1 = require("@material-ui/core/styles");
var useMediaQuery_1 = tslib_1.__importDefault(require("@material-ui/core/useMediaQuery"));
exports.useIsBreakpointUp = function (breakpoint) {
    var theme = styles_1.useTheme();
    return useMediaQuery_1.default(theme.breakpoints.up(breakpoint));
};
exports.useIsBreakpointDown = function (breakpoint) {
    var theme = styles_1.useTheme();
    return useMediaQuery_1.default(theme.breakpoints.down(breakpoint));
};
